import React from "react";
import config from "../../config";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import SearchMenu from "./SearchMenu";

class SearchBar extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            focus: false
        };

        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleInputFocus() {
        this.setState({ focus: true });
    };

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ focus: false });
        }
    }

    render () {
        const {
            handleSearchChange, searchValue, trendingSearches,
            popularBags, mobile, top_promo_banner_not_visible, searchNoResults,
            search_focus_parent_component, focusInsideSearch, isCheckoutPage
        } = this.props;
        const {focus} = this.state;

        return (
            <div
                className="search-bar"
                ref={this.setWrapperRef}
                onFocus={focusInsideSearch}
            >
                <Form inline action={`${config.host_rebag_shop}/search`}>
                    <InputGroup>
                        <InputGroup.Prepend>
                            <span className="icon-search"></span>
                        </InputGroup.Prepend>
                        <FormControl
                            placeholder='Try searching "Louis Vuitton" or "Black Tote"'
                            aria-label="Search"
                            name="q"
                            autoFocus={!!mobile}
                            autoComplete="off"
                            onChange={handleSearchChange ? (event) => this.props.handleSearchChange(event.target.value) : null}
                            onFocus={this.handleInputFocus}
                        />
                        <span id="bc-search-close" className="hide icon-close"></span>
                    </InputGroup>
                </Form>
                {focus && search_focus_parent_component && !searchValue && !mobile &&
                <SearchMenu
                    mobile={mobile}
                    trendingSearches={trendingSearches}
                    popularBags={popularBags}
                    top_promo_banner_not_visible={top_promo_banner_not_visible}
                    searchNoResults={searchNoResults}
                    isCheckoutPage={isCheckoutPage}
                />
                }
                {!searchValue && search_focus_parent_component && mobile &&
                <SearchMenu
                    mobile={mobile}
                    trendingSearches={trendingSearches}
                    popularBags={popularBags}
                    top_promo_banner_not_visible={top_promo_banner_not_visible}
                    searchNoResults={searchNoResults}
                    isCheckoutPage={isCheckoutPage}
                />
                }
            </div>
        )
    }
}

export default SearchBar;